import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { NavLink } from "react-router-dom";
import TitleSection from "../../components/TitleBar/TitleSection";
//import Trending from '../../components/TrendingNow/Trending';
import PresentationCard from "components/PresentationCard/PresentationCard";
import axios from "axios";
import Form from "react-bootstrap/Form";
import TabContainer from "react-bootstrap/TabContainer";
import Button from "../../components/Button/Button";
import Footer from "components/Footer/Footer";
import { searchUrl, HeaderConfig } from "Api/Api";
import {
  org_friendly_url,
  user_Status,
  user_API,
  myHeaders_Autorized,
  user_entity_uuid,
} from "Api/Api";
import FavouriteModal from "components/FavoriteModal/FavoriteModal";
import Modal from "react-bootstrap/Modal";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import EmptyMessage from "components/EmptyMessage/EmptyMessage";
import { local_routes } from "utils/Routes";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import home from "Assets/home.svg";

let eventImg =
  "https://d3vhc53cl8e8km.cloudfront.net/hello-staging/wp-content/uploads/2017/12/22223742/Events-1200x630.jpg";
let TrendingNowArr = [
  {
    id: 1,
    Trending_img: eventImg,
    Trending_now_title: "Drwan from the present",
    Trending_now_text:
      "Collin Hamman never takes his time for granted and makes a point of using each moment as a possibility for inspration. His graphic design.",
  },
  {
    id: 2,
    Trending_img: eventImg,
    Trending_now_title: "Drwan from the present",
    Trending_now_text:
      "Collin Hamman never takes his time for granted and makes a point of using each moment as a possibility for inspration. His graphic design.",
  },
];
const MAX_ITEMS = 15;
let favTotalItems = [];

const Category = (props) => {
  const [categories, set_categories] = useState([]);
  const [user_fav_present_temp_arr, set_user_fav_present_temp_arr] = useState(
    []
  );
  const [checked, set_checked] = useState(false);
  const [loading, set_loading] = useState(true);
  const [show, set_show] = useState(false);
  const [category_presentation_arr, set_category_presentation_arr] = useState(
    []
  );
  const [is_open, set_is_open] = useState(true);
  const [user_oth_presentation_arr, set_user_oth_presentation_arr] = useState(
    []
  );
  const [user_fav_presentation_arr, set_user_fav_presentation_arr] = useState(
    []
  );
  const [filtered_total_cat_items, set_filtered_total_cat_items] = useState([]);
  const [filtered_total_fav_items, set_filtered_total_fav_items] = useState([]);
  const [favourites_available, set_favourites_available] = useState(true);
  const [category_sort, set_category_sort] = useState("Trending PKs");
  const [is_loading_category, set_is_loading_category] = useState(false);
  const [is_loading_other_category, set_is_loading_other_category] =
    useState(false);

  let workspace_base_url = "";
  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace + "/" + org_friendly_url;
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    const loadCategory = {
      loadFavoriteCategory: true,
      loadOtherCategory: true,
    };
    NewAPICallPromises("", loadCategory);
  }, []);

  //JBB this will handle getting data from API - logged-in or not
  const NewAPICallPromises = async (force_sort, categoryLoad) => {
    let sort_type_map = {
      "Trending PKs": "view_count",
      "Recent PKs": "created_time",
    };
    let Category_Type = "view_count"; // default
    if (force_sort) {
      Category_Type = sort_type_map[force_sort];
    } else if (category_sort) {
      Category_Type = sort_type_map[category_sort];
    }
    try {
      let initial_promises = [];
      initial_promises.push(
        axios.get(
          `${searchUrl}all_categories_presentationsearch?get_presenter=true&sort_by=${Category_Type}&sort_order=DESC&limit=2`,
          HeaderConfig
        )
      );
      if (user_Status === 1) {
        initial_promises.push(
          axios.get(
            `${user_API}/${user_entity_uuid}/categories.audience`,
            myHeaders_Autorized
          )
        );
      }
      let [allCategoriesRes, favCategoriesRes] = await Promise.all(
        initial_promises
      );
      let categories = allCategoriesRes.data;
      // sort them!
      categories = categories.sort((a, b) =>
        a.entity_name > b.entity_name ? 1 : -1
      );
      let favArr = []; // user favorites
      let catArr = []; // user non-favorites
      // make fav cat obj for easy retrieval later
      let tmp_fav_cat_obj = {};
      if (user_Status === 1 && favCategoriesRes) {
        for (let tmp_fav_cat of favCategoriesRes.data) {
          if (
            tmp_fav_cat.xref_data &&
            tmp_fav_cat.xref_data.favorited_time &&
            tmp_fav_cat.xref_data.favorited_time > 0
          ) {
            tmp_fav_cat_obj[tmp_fav_cat.entity_uuid] = tmp_fav_cat;
          }
        }
        // lets put fav cats at top of categories array
        let tmp_nonfav_categories = [];
        let tmp_fav_categories = []; // build this so we maintain alphabetical
        for (let i = 0; i < categories.length; i++) {
          let tmp_cat = categories[i];
          if (tmp_fav_cat_obj[tmp_cat.entity_uuid]) {
            tmp_fav_categories.push(tmp_cat);
          } else {
            tmp_nonfav_categories.push(tmp_cat);
          }
        }
        categories = tmp_fav_categories.concat(tmp_nonfav_categories);
      }

      // build right-hand cat list for logged-in users
      if (user_Status === 1) {
        for (let tmp_cat_obj of categories) {
          if (tmp_fav_cat_obj[tmp_cat_obj.entity_uuid]) {
            favArr.push(tmp_cat_obj);
          } else {
            catArr.push(tmp_cat_obj);
          }
        }
        set_filtered_total_fav_items(favArr);
        set_is_loading_category(false);
        set_is_loading_other_category(false);
        set_filtered_total_cat_items(catArr);
      } else {
        set_is_loading_category(false);
        set_is_loading_other_category(false);
        set_categories(categories); // right-hand cat list for non-logged-in users
      }

      let presenTempArr = [];
      let userFavpresenTempArr = [];
      let user_Oth_Presentation_Arr = [];

      for (let category of categories) {
        if (user_Status === 1) {
          if (tmp_fav_cat_obj[category.entity_uuid]) {
            userFavpresenTempArr.push({
              category_Name: category.entity_name,
              friendly_url: category.friendly_url,
              category_Presentation_Arr:
                category.presentations.search_query_results,
            });
          } else {
            user_Oth_Presentation_Arr.push({
              category_Name: category.entity_name,
              friendly_url: category.friendly_url,
              category_Presentation_Arr:
                category.presentations.search_query_results,
            });
          }
        } else {
          presenTempArr.push({
            category_Name: category.entity_name,
            friendly_url: category.friendly_url,
            category_Presentation_Arr:
              category.presentations.search_query_results,
          });
        }
      }
      if (categoryLoad.loadFavoriteCategory) {
        set_user_fav_presentation_arr(userFavpresenTempArr);
        set_loading(false);
      }
      if (categoryLoad.loadOtherCategory) {
        set_user_oth_presentation_arr(user_Oth_Presentation_Arr);
        set_category_presentation_arr(presenTempArr);
        set_loading(false);
      }
    } catch (err) {
      console.error(err);
    }
  };
  // This method is the condition for show more/less categories
  const toggle = () => {
    set_is_open(!is_open);
  };

  // This method is the logic for show more/less categories
  const getRenderedItems = () => {
    if (user_Status === 1) {
      if (is_open) {
        return filtered_total_cat_items;
      }
      return filtered_total_cat_items.slice(0, MAX_ITEMS);
    } else {
      if (is_open) {
        return categories;
      }
      return categories.slice(0, MAX_ITEMS);
    }
  };
  const handleChangeFromYourFavourites = (e) => {
    set_category_sort(e.target.value);
    set_is_loading_category(true);

    const loadCategory = {
      loadFavoriteCategory: true,
      loadOtherCategory: false,
    };
    NewAPICallPromises(e.target.value, loadCategory);
  };

  // This method to change sorting of presentations for no user categrories
  // does not matter if you are logged-in or not - call this one
  const handleChangeOtherCategories = (e) => {
    set_is_loading_other_category(true);
    set_category_sort(e.target.value);
    const loadCategory = {
      loadFavoriteCategory: false,
      loadOtherCategory: true,
    };
    NewAPICallPromises(e.target.value, loadCategory);
  };
  // Toogles modal show
  const showModal = () => {
    set_show(true);
  };
  // Toogles modal hide
  const hideModal = () => {
    set_show(false);
  };

  if (loading) {
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>PechaKucha Categories</title>
        </Helmet>
        <FullPageSpinner />
      </React.Fragment>
    );
  }
  console.log("FAVORITE PRESENTAION ARR:", user_fav_presentation_arr);
  console.log("USER STATUS:", user_Status);
  return (
    <>
      <Helmet defer={false}>
        <title>PechaKucha Categories</title>
      </Helmet>
      <div className="CategoryPage">
        <div className="container">
          <div className="trending-categories">
            <Row className="mb-view">
              <Col lg={8} md={12}>
                <div className="categories">
                  {user_Status === 1 && user_fav_presentation_arr.length > 0 ? (
                    //   {user_Status === 1 || user_fav_presentation_arr.length > 0 ? (
                    <div>
                      {/* User Fav presentations section */}
                      <div className="favorites">
                        <h3 className="trending-heading">
                          From Your Followed Categories
                        </h3>
                        <Form>
                          <Form.Group>
                            <div className="form-dropdownlist">
                              <Form.Control
                                as="select"
                                required
                                onChange={handleChangeFromYourFavourites}
                                defaultValue={category_sort}
                              >
                                <option>Trending PKs</option>
                                <option>Recent PKs</option>
                              </Form.Control>
                            </div>
                          </Form.Group>
                        </Form>
                      </div>
                      <div className={is_loading_category ? "hello" : ""}>
                        {!is_loading_category ? (
                          <div className="case-studies">
                            {user_fav_presentation_arr.length > 0 ? (
                              <div id="home">
                                {user_fav_presentation_arr.map((item) => {
                                  return (
                                    <div
                                      key={item.category_Name}
                                      style={{
                                        display:
                                          item.category_Presentation_Arr
                                            .length === 0
                                            ? "none"
                                            : null,
                                      }}
                                    >
                                      <div className="case-studies">
                                        <div id="home">
                                          <TitleSection
                                            title={item.category_Name}
                                            seeAll={
                                              user_fav_presentation_arr.length >
                                              0
                                                ? "true"
                                                : "false"
                                            }
                                            Title_link={`${workspace_base_url}${local_routes.categories}/${item.friendly_url}`}
                                          />

                                          <Row>
                                            {item.category_Presentation_Arr.map(
                                              (data) => {
                                                return (
                                                  <Col
                                                    key={
                                                      data.entity_info
                                                        .entity_uuid
                                                    }
                                                    lg={6}
                                                    sm={12}
                                                    md={6}
                                                  >
                                                    <PresentationCard
                                                      key={
                                                        data.entity_info
                                                          .entity_uuid
                                                      }
                                                      presentation_info={
                                                        data.entity_info
                                                      }
                                                    />
                                                  </Col>
                                                );
                                              }
                                            )}
                                          </Row>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <EmptyMessage empty_message="No Followed Categories" />
                            )}
                          </div>
                        ) : (
                          <ActivityIndicator theme="spinner" />
                        )}
                      </div>
                    </div>
                  ) : null}
                  <div>
                    {user_Status === 1 ? (
                      <React.Fragment>
                        {/* User other category presentations */}
                        <div className="favorites">
                          <h3 className="trending-heading">
                            {user_fav_presentation_arr.length > 0
                              ? "Other "
                              : null}
                            Categories
                          </h3>
                          <Form>
                            <Form.Group>
                              <div className="form-dropdownlist">
                                <Form.Control
                                  as="select"
                                  required
                                  onChange={handleChangeOtherCategories}
                                  defaultValue={category_sort}
                                >
                                  <option>Trending PKs</option>
                                  <option>Recent PKs</option>
                                </Form.Control>
                              </div>
                            </Form.Group>
                          </Form>
                        </div>
                        <div
                          className={is_loading_other_category ? "hello" : ""}
                        >
                          {!is_loading_other_category ? (
                            <>
                              {user_oth_presentation_arr.length > 0 ? (
                                <>
                                  {user_oth_presentation_arr.map((item) => {
                                    return (
                                      <div
                                        key={item.friendly_url}
                                        style={{
                                          display:
                                            item.category_Presentation_Arr
                                              .length === 0
                                              ? "none"
                                              : null,
                                        }}
                                      >
                                        <div className="case-studies">
                                          <div id="home">
                                            <TitleSection
                                              title={item.category_Name}
                                              seeAll={
                                                TrendingNowArr.length > 0
                                                  ? "true"
                                                  : "false"
                                              }
                                              Title_link={`${workspace_base_url}${local_routes.categories}/${item.friendly_url}`}
                                            />

                                            <Row>
                                              {item.category_Presentation_Arr.map(
                                                (data) => {
                                                  return (
                                                    <Col
                                                      key={
                                                        data.entity_info
                                                          .entity_uuid
                                                      }
                                                      lg={6}
                                                      sm={12}
                                                      md={6}
                                                    >
                                                      <PresentationCard
                                                        key={
                                                          data.entity_info
                                                            .entity_uuid
                                                        }
                                                        presentation_info={
                                                          data.entity_info
                                                        }
                                                      />
                                                    </Col>
                                                  );
                                                }
                                              )}
                                            </Row>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </>
                              ) : (
                                <EmptyMessage empty_message="No other Categories" />
                              )}
                            </>
                          ) : (
                            <ActivityIndicator theme="spinner" />
                          )}
                        </div>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <div className="favorites">
                          {/* No user Category based presentations */}
                          <h3 className="trending-heading">All Categories</h3>
                          <Form>
                            <Form.Group>
                              <div className="form-dropdownlist">
                                <Form.Control
                                  as="select"
                                  required
                                  onChange={handleChangeOtherCategories}
                                  defaultValue={category_sort}
                                >
                                  <option>Trending PKs</option>
                                  <option>Recent PKs</option>
                                </Form.Control>
                              </div>
                            </Form.Group>
                          </Form>
                        </div>
                        <div
                          className={is_loading_other_category ? "hello" : ""}
                        >
                          {!is_loading_other_category ? (
                            <>
                              {category_presentation_arr.map((item) => {
                                return (
                                  <div
                                    key={item.category_Name}
                                    style={{
                                      display:
                                        item.category_Presentation_Arr
                                          .length === 0
                                          ? "none"
                                          : null,
                                    }}
                                  >
                                    <div className="case-studies">
                                      <div id="home">
                                        <TitleSection
                                          title={item.category_Name}
                                          seeAll={
                                            TrendingNowArr.length > 0
                                              ? "true"
                                              : "false"
                                          }
                                          Title_link={`${workspace_base_url}${local_routes.categories}/${item.friendly_url}`}
                                        />

                                        <Row>
                                          {item.category_Presentation_Arr.map(
                                            (data) => {
                                              return (
                                                <Col
                                                  key={
                                                    data.entity_info.entity_uuid
                                                  }
                                                  lg={6}
                                                  sm={12}
                                                  md={6}
                                                >
                                                  <PresentationCard
                                                    key={
                                                      data.entity_info
                                                        .entity_uuid
                                                    }
                                                    presentation_info={
                                                      data.entity_info
                                                    }
                                                  />
                                                </Col>
                                              );
                                            }
                                          )}
                                        </Row>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </>
                          ) : (
                            <ActivityIndicator theme="spinner" />
                          )}
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </Col>
              <Col lg={4} md={12}>
                <div className="categories-list">
                  {user_Status === 1 ? (
                    <div className="favorite-category">
                      {/* user Category list */}
                      <h3 className="favorite-heading">
                        My Followed Categories
                      </h3>
                      {filtered_total_fav_items.length > 0 ? (
                        <div>
                          {filtered_total_fav_items.map((data) => (
                            <NavLink
                              key={data.friendly_url}
                              to={{
                                pathname: `${workspace_base_url}${local_routes.categories}/${data.friendly_url}`,
                                state: {
                                  entityData: data,
                                  status: true,
                                  userFavCategories: favTotalItems,
                                  checked: true,
                                },
                              }}
                            >
                              <div
                                key={data.entity_uuid}
                                className="categoryItem"
                              >
                                {data.entity_name}
                              </div>
                            </NavLink>
                          ))}
                        </div>
                      ) : (
                        <EmptyMessage empty_message="No Followed Categories" />
                      )}

                      {/* Modal section */}
                      <div className="modal-content-custom">
                        <Modal
                          style={{ color: "black" }}
                          size="lg"
                          show={show}
                          onHide={hideModal}
                          className="modal-content-custom"
                        >
                          <div>
                            <FavouriteModal
                              totalFavItems={filtered_total_fav_items}
                            />
                          </div>
                          <div>
                            <Button theme="modal-button" OnClickMet={hideModal}>
                              x
                            </Button>
                          </div>
                        </Modal>
                        <Button
                          theme="btn-global btn-green btn-favorite"
                          OnClickMet={showModal}
                        >
                          Edit Followed Categories
                        </Button>
                      </div>
                    </div>
                  ) : null}
                  {user_Status === 1 ? (
                    <>
                      {filtered_total_cat_items.length !== 0 && (
                        <div className="favorite-category">
                          {/* all categories for no user section */}
                          <h3 className="favorite-heading">All Categories</h3>
                          <TabContainer
                            id="left-tabs-example"
                            defaultActiveKey="first"
                          >
                            <div>
                              {getRenderedItems().map((item, id) => (
                                <NavLink
                                  key={item.friendly_url}
                                  to={{
                                    pathname: `${workspace_base_url}${local_routes.categories}/${item.friendly_url}`,
                                    state: {
                                      entityData: item,
                                      status: true,
                                      userFavCategories: favTotalItems,
                                    },
                                  }}
                                >
                                  <div key={id} className="categoryItem">
                                    {item.entity_name}
                                  </div>
                                </NavLink>
                              ))}
                              {filtered_total_cat_items.length > 15 && (
                                <button
                                  onClick={toggle}
                                  className="btn-moreCategories"
                                >
                                  {is_open
                                    ? "View Less Categories"
                                    : "View More Categories"}
                                </button>
                              )}
                            </div>
                          </TabContainer>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="favorite-category">
                      <h3 className="favorite-heading">All Categories</h3>
                      <TabContainer
                        id="left-tabs-example"
                        defaultActiveKey="first"
                      >
                        <div>
                          {getRenderedItems().map((item, id) => (
                            <NavLink
                              key={item.entity_uuid}
                              to={{
                                pathname: `${workspace_base_url}${local_routes.categories}/${item.friendly_url}`,
                                state: {
                                  entityData: item,
                                  status: true,
                                  userFavCategories: favTotalItems,
                                },
                              }}
                            >
                              <div key={id} className="categoryItem">
                                {item.entity_name}
                              </div>
                            </NavLink>
                          ))}
                          {categories.length > 15 && (
                            <button
                              onClick={toggle}
                              className="btn-moreCategories"
                            >
                              {is_open
                                ? "View Less Categories"
                                : "View More Categories"}
                            </button>
                          )}
                        </div>
                      </TabContainer>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <Footer
          homeImg={home}
          homeImgRef={workspace_base_url ? workspace_base_url : "/"}
          breadcrumbSubPage="Categories"
        />
      </div>
    </>
  );
};

export default Category;
